<template>
  <section class="feed-text-con">
    <div class="feed-text">
      <span class="vote" v-if="voteOption">
        <img class="vote-head" :src="voteImgHead" alt="" />
        <span :class="['vote-text', `vote-${voteOption.index + 1}`]">
          {{voteOption.optionText}}
        </span>
      </span>
      <span class="item" v-for="(item, index) in items" :key="index">
        <span class="text" v-if="item.resourceType === 'Text'">{{item.text}}</span>
        <a class="link" v-else-if="item.resourceType === 'Url'" :href="item.url">
          <span class="icon"></span>
          <span class="title">
            {{item.title.length > 30 ? item.title.slice(0,30) + '...' : item.title}}
          </span>
        </a>
      </span>
    </div>
  </section>
</template>
<script>

export default {
  name: 'FeedTextItem',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    voteOption: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      voteImgHead: this.voteOption && require(`../../assets/tag_topic_0${this.voteOption.index + 1}@3x_cut_01.png`)
    }
  }
}
</script>
<style lang="scss" scoped>
.feed-text-con {
  padding: .32rem 0 .26rem 0;
}
.feed-text {
  font-family: HYQiHei-EZS;
  font-size: .32rem;
  color: #444444;
  letter-spacing: 0;
  line-height: .58rem;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
  .vote {
    height: .6rem;
    margin-left: -.3rem;
    display: inline-block;
    transform: scale(0.8);
    .vote-text {
      display: inline-block;
      height: .48rem;
      line-height: .48rem;
      padding: 0 .16rem;
      font-family: HYQiHei-EZS;
      font-size: .22rem;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      vertical-align: middle;
      position: relative;
      z-index: 9;
      border-top-right-radius: .24rem;
      border-bottom-right-radius: .24rem;
      text-indent: -.2rem;
    }
    .vote-head {
      height: .6rem;
      vertical-align: middle;
      position: relative;
      right: -.3rem;
      z-index: 1;
    }
    .vote-foot {
      height: .6rem;
      vertical-align: middle;
      position: relative;
      left: -.28rem;
      z-index: 1;
    }
    .vote-1 {
      background-color: #5F7CCC;
    }
    .vote-2 {
      background-color: #F57979;
    }
    .vote-3 {
      background-color: #FFDA8F;
    }
  }
  .item {
    display: inline;
    .text {
      white-space: pre-wrap;
    }
    .link {
      color: #308f8b;
      word-break: break-all;
      .icon {
        display: inline-block;
        width: .32rem;
        height: .32rem;
        background: url('../../assets/text_link_ic@3x.png');
        background-size: contain;
        vertical-align: middle;
        margin-right: -.1rem;
      }
    }
  }
}
</style>
